import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DropdownStatusList, EmptyString, FormTypeAdd, FormTypeEdit, PageSize, PageTypeGetPaged } from "utils/Constant";
import Dropdown from "components/Input/Dropdown";
import { GetStatus } from "utils/helpers"
import AddButton from "components/Button/AddButton";
import CheckCircleIcon from "assets/icon/CheckCircleIcon";
import { MainBodyCard } from "components/Cards/MainBodyCard";
import { PagesTitle } from "components/Cards/PagesTitle";
import { FilterCard } from "components/Cards/FilterCard";
import { useModal } from "utils/context/ModalContext";
import { AuthService } from "services/AuthService";
import { UserService } from "services/UserService";
import DataTable from "components/DataTable";
import { GridEditButton } from "components/Button/GridEditButton";
import { GridDeleteButton } from "components/Button/GridDeleteButton";
import Pagination from "components/Input/PaginationButton";

export default function User(){
    let navigate = useNavigate()

    const firstLoad = useRef(true)
    const debounceRef = useRef(null)

    const { showFail, showLoading, hideLoading, showSuccess, confirm } = useModal()

    const { fetchCheckIsAdmin } = AuthService()
    const { fetchUserList, fetchDeleteUser } = UserService()

    // FILTER
    const [username, setUsername] = useState(EmptyString)
    const [name, setName] = useState(EmptyString)
    const [status, setStatus] = useState(DropdownStatusList[1].value)
    const [statusOptions, setStatusOptions] = useState(DropdownStatusList)

    // DATA
    const [userList, setUserList] = useState([])

    // GRID
    const [pageIndex, setPageIndex] = useState(0)
    const [totalPages, setTotalPages] = useState(0)

    const columns = [
        {
            key: "rowNumber",
            header: "No",
            headerClassName: "w-16 font-semibold",
            cellClassName: "text-center"
        },
        {
            key: "username",
            header: "Username",
        },
        {
            key: "firstName",
            header: "Name",
            render: (row) => row.firstName.toUpperCase() + ' ' + row.lastName.toUpperCase()
        },
        {
            key: "isAdmin",
            header: "Admin",
            render: (row) => row.isAdmin ? <CheckCircleIcon /> : ""
        },
        {
            key: "status",
            header: "Status",
            render: (row) => GetStatus(row.status),
        },
        {
            key: "action",
            header: "Action",
            render: (row) => (
                <div className="flex gap-2">
                    <GridEditButton isActive={row.status} onClick={() => editBtnClick(row.userId)} size="w-3" />
                    <GridDeleteButton isActive={row.status} onClick={() => deleteBtnClick(row.userId, row.status)} size="w-3" />
                </div>
            ),
        },
    ]

    const handlePageChange = async (newIndex) => {
        try {
            showLoading()

            const res = await fetchUserList(
                username,
                name, 
                status,
                PageSize,
                parseInt(newIndex),
                PageTypeGetPaged,
                "A.Username",
                "ASC"
            )

            if (!res) return

            const totalData = res?.data?.totalData ?? 0;
            const total = Math.max(1, Math.ceil(totalData / PageSize));

            setUserList(res)
            setTotalPages(total)
            setPageIndex(newIndex)
        } finally {
            hideLoading()
        }
    }

    // BUTTON
    const addBtnClick = () => {
        navigate("/setting/user/form?userId=&formType=" + FormTypeAdd)
    }
    const editBtnClick = (userId) => {
        navigate("/setting/user/form?userId=" + userId + "&formType=" + FormTypeEdit)
    }
    const deleteBtnClick = async (userId, status) => {
        const onConfirm = await confirm()
        if (!onConfirm) return

        try {
            showLoading()

            await fetchDeleteUser(userId, status)
            await handlePageChange(pageIndex)
        } finally {
            hideLoading()
        }
    }
    

    useEffect(() => {
        const onLoad = async () => {
            try {
                if (firstLoad.current) {
                    const res = await fetchCheckIsAdmin(localStorage.getItem("UserId"))
                    if (!res) return

                    if (res.data.isAdmin === false){
                        showFail("User don't have admin access right!")
                    }

                    await handlePageChange(0)

                    firstLoad.current = false
                }
                else {
                    if (debounceRef.current) {
                        clearTimeout(debounceRef.current)
                    }
            
                    debounceRef.current = setTimeout(async () => {
                        await handlePageChange(0)
                    }, 500)
                }
            } finally {
                hideLoading()
            }
        }

        onLoad()
    },[])

    return(
        <MainBodyCard>
            <PagesTitle title='User' />

            <div className="flex flex-col sm:flex-row gap-8 mt-4">
                <FilterCard title='Username'>
                    <input className="input" value={ username } onChange={(e) => { setUsername(e.target.value) }} />
                </FilterCard>

                <FilterCard title='Name'>
                    <input className="input" value={ name } onChange={(e) => { setName(e.target.value) }} />
                </FilterCard>

                <FilterCard title='Username'>
                    <Dropdown className='w-full' value={status} options={statusOptions} onChange={(e) => { setStatus(e.value) }} placeholder={"All"} />
                </FilterCard>
            </div>

            <div className="mt-4 flex w-full justify-end">
                <AddButton onClick={addBtnClick} title='Tambah User' />
            </div>
           
            <div className="mt-4">
                <DataTable
                    columns={columns}
                    data={userList?.data?.listData ?? []}
                />
            </div>

            <Pagination pageIndex={pageIndex} totalPages={totalPages} onPageChange={handlePageChange} />
        </MainBodyCard>
    )
}